import React from "react";
import Network from "./Network";

export const New = () => {
  return <Network type="New" />;
};

export default New;
